<section>
  <div *ngFor="let element of data" class="section-div">
    <ion-text class="element-title">{{ element.sectionTitle }}</ion-text>
    <div class="helper-div"></div>
    <div *ngFor="let subSection of element.sections" [class]="getSubCardClass(subSection)">
      <ion-button
        (click)="setActiveAndExecuteAction(subSection)" 
        (keypress)="true"
        [class]="getSubCardButtonClass(subSection)" 
        fill="clear"
      >
        {{subSection.title}}
      </ion-button>
    </div>
  </div>

  <div *ngIf="isHelp" class="help-container">
    <h3>¿Necesitas ayuda?</h3>
    <div class="help-card">
      <p>Solicita una Video atención con uno de nuestros ejecutivos</p>
      <button class="schedule-button" (click)="goToVideoAtencion()">Agendar Video Atención</button>
    </div>
  </div>

  <div *ngIf="isInterest" class="interest-container">
    <h3>Te puede interesar</h3>
    <div class="interest-card">
      <button class="schedule-button" (click)="goToOneText()">
        <ng-container *ngIf="isReforma; else notReforma">
          <p>{{interestOneText}}</p>
          <img src="/assets/reforma-pensiones/revisar.svg" alt="">
        </ng-container>
        <ng-template #notReforma>
          <p>{{interestOneText}}</p>
        </ng-template>
      </button>
      <button class="schedule-button" (click)="goToTwoText()">
        <ng-container *ngIf="isReforma; else notReformaTwo">
          <p>{{interestTwoText}}</p>
          <img src="/assets/reforma-pensiones/revisar.svg" alt="">
        </ng-container>
        <ng-template #notReformaTwo>
          <p>{{interestTwoText}}</p>
        </ng-template>
      </button>
    </div>
  </div>
</section>
